import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import UdcSelect from '@/components/common/UdcSelect.vue'
import Popup from '@/components/common/Popup/Popup.vue'

const pinia = createPinia()

const app = createApp(App)

app.use(router)
app.use(pinia)
app.component('UdcSelect', UdcSelect)
app.component('Popup', Popup)
app.mount('#app')

export default app
